import Model from './Model'

export default class OrderItem extends Model {
    resource() {
        return 'order-items'
    }

    primaryKey() {
        return 'uuid'
    }
}
